export enum StepsNotClientTypes {
  STEP_PUBLIC_LANDING = '[Steps] StepNotClientInputData Access',
  STEP_PUBLIC_LANDING_FOREIGN = '[Steps] StepNotClientInputDataForeign Access',
  STEP_PUBLIC_LANDING_FOREIGN_JOINT = '[Steps] StepNotClientJointInputDataForeign Access',
  STEP_OFFER = '[Steps] StepOffer Access',
  STEP_ADDRESS_DATA = '[Steps] StepNotClientAddressData Access',
  STEP_NO_OFFER = '[Steps] StepNotClientNoOffer Access',
  STEP_INFORMATION_LABOR_CLIENT = '[Steps] StepInformationLaborClient Access',
  STEP_NATIONALITY = '[Steps] StepNationality Access',
  STEP_INFORMATION_PEP = '[Steps] PEP Component',
  STEP_CURRENCY_TYPE = '[Steps] StepConfig1 Access',
  STEP_TERMS_CONDITIONS = '[Steps] Terminos y condiciones',
  STEP_CREATE_PRODUCT = '[Steps] Creation product component',
  STEP_CONFIG_4 = '[Steps] StepNotClientConfig4 Access',
  STEP_JOINT_CONFIG_4 = '[Steps] StepNotClientJointConfig4 Access',
  SUCCESS_PROCESS = '[Steps] StepNotClientConfig5 Access',
  STEP_JOINT_ADDRESS_DATA = '[Steps] StepNotClientJointAddressData Access',
  STEP_JOINT_INFORMATION_1 = '[Steps] StepNotClientJointInformation1 Access',
  STEP_JOINT_NATIONALITY = '[Steps] StepJointNationality Access',
  STEP_INFORMATION_PEP_JOINT = '[Steps] PEP joint component',
  STEP_SERVICE_ERROR = '[Steps] ServiceErrorNotClient',
  STEP_SUCURSAL_DERIVATION = '[Steps] SucursalDerivationNotClient',
  STEP_DERIVATION = '[Steps] Derivation',
  STEP_ABR_LIGHT = '[Steps] ABR Light',
  STEP_CONTRACT_SIGNING = '[Steps] ContractSigningNotClient',
  STEP_FACE_RECOGNITION = '[Steps] FaceRecognitionNotClient',
  STEP_CREATE_PASSWORD = '[Steps] CreatePassword',
  STEP_MAINTENANCE = '[Steps] Maintenance',
  STEP_JOINT_CREATE_PRODUCT = '[Steps] Product joint create'
}

export enum StepsClientTypes {
  STEP_PRIVATE_LANDING_JOINT = '[Steps] StepClientInputData Access',
  STEP_OFFER = '[Steps] StepOffer Access',
  STEP_CURRENCY_TYPE = '[Steps] StepConfig1 Access',
  SUCCESS_PROCESS = '[Steps] Account opening',
  STEP_CONFIG_4_MOBILE = '[Steps] StepClientConfig4Mobile Access',
  STEP_INFORMATION_LABOR_CLIENT = '[Steps] StepInformationLabor Access',
  STEP_NATIONALITY = '[Steps] StepNationality Access',
  STEP_INFORMATION_PEP = '[Steps] StepInformation Access',
  STEP_NO_OFFER = '[Steps] No offer',
  STEP_JOINT_INFORMATION_LABOR_CLIENT = '[Steps] StepJointInformationLabor Access',
  STEP_JOINT_NATIONALITY_CLIENT = '[Steps] StepJointNationality Access',
  STEP_INFORMATION_PEP_JOINT = '[Steps] StepJointInformation Access',
  STEP_SERVICE_ERROR = '[Steps] ServiceError',
  STEP_TERMS_CONDITIONS = '[Steps] StepConfig2Access',
  STEP_CREATE_PRODUCT = '[Steps] Product creating',
  STEP_CONFIG_4_CLIENT_MOBILE = '[Steps] StepConfig4Mobile Access',
  STEP_SUCURSAL_DERIVATION = '[Steps] Sucursal Derivation',
  STEP_DERIVATION = '[Steps] Derivation',
  STEP_UPDATE_DATA = '[Steps] Update Data',
  STEP_CREATE_PASSWORD = '[Steps] CreatePassword',
  STEP_CLIENT_SOFTOKEN_VU = '[Steps] Softoken Vu FastTrack',
  STEP_MAINTENANCE = '[Steps] Maintenance',
  STEP_JOINT_CREATE_PRODUCT = '[Steps] Product joint create'
}

export enum ClientAdmissionTypes {
  CAE = '[Onboarding] call ClientAdmission service',
  CAE_SUCCESS = '[Onboarding] call ClientAdmission service success',
  CAE_ERROR = '[Onboarding] call ClientAdmission service error',
  CLEAN_STATE = '[Onboarding] call ClientAdmission service CLEAN_STATE'
}

export enum EmailValidateTypes {
  EMAIL_VALIDATE = '[Onboarding] call EmailValidate service',
  EMAIL_VALIDATE_SUCCESS = '[Onboarding] call EmailValidate service success',
  EMAIL_VALIDATE_ERROR = '[Onboarding] call EmailValidate service error',
  CLEAN_STATE = '[Onboarding] call EmailValidate service CLEAN_STATE'
}

export enum IsCTSEmployeeTypes {
  IS_CTS_EMPLOYEE = '[Onboarding] call IsCTSEmployee service',
  IS_CTS_EMPLOYEE_SUCCESS = '[Onboarding] call IsCTSEmployee service success',
  IS_CTS_EMPLOYEE_ERROR = '[Onboarding] call IsCTSEmployee service error',
  CLEAN_STATE = '[Onboarding] call IsCTSEmployee service CLEAN_STATE'
}

export enum ReqManagerGetTypes {
  REQUEST_MANAGER_GET = '[Onboarding] call GetRequestManager service ',
  REQUEST_MANAGER_GET_SUCCESS = '[Onboarding] call GetRequestManager service success ',
  REQUEST_MANAGER_GET_ERROR = '[Onboarding] call GetRequestManager service error ',
  CLEAN_STATE = '[Onboarding] call GetRequestManager service CLEAN_STATE'
}

export enum ReqManagerCreateTypes {
  REQUEST_MANAGER_CREATE = '[Onboarding] call RequestManagerCreate service ',
  REQUEST_MANAGER_CREATE_SUCCESS = '[Onboarding] call RequestManagerCreate service success ',
  REQUEST_MANAGER_CREATE_ERROR = '[Onboarding] call RequestManagerCreate service error ',
  CLEAN_STATE = '[Onboarding] call RequestManagerCreate service CLEAN_STATE'
}

export enum AddressManagerCreateTypes {
  ADDRESS_MANAGER_CREATE = '[Onboarding] call AddressManagerCreate service ',
  ADDRESS_MANAGER_CREATE_SUCCESS = '[Onboarding] call AddressManagerCreate service success ',
  ADDRESS_MANAGER_CREATE_ERROR = '[Onboarding] call AddressManagerCreate service error ',
  CLEAN_STATE = '[Onboarding] call AddressManagerCreate service CLEAN_STATE'
}

export enum LaborManagerCreateTypes {
  LABOR_MANAGER_CREATE = '[Onboarding] call LaborManagerCreate service ',
  LABOR_MANAGER_CREATE_SUCCESS = '[Onboarding] call LaborManagerCreate service success ',
  LABOR_MANAGER_CREATE_ERROR = '[Onboarding] call LaborManagerCreate service error ',
  CLEAN_STATE = '[Onboarding] call LaborManagerCreate service CLEAN_STATE'
}

export enum NationalityManagerCreateTypes {
  NATIONALITY_MANAGER_CREATE = '[Onboarding] call NationalityManagerCreate service ',
  NATIONALITY_MANAGER_CREATE_SUCCESS = '[Onboarding] call NationalityManagerCreate service success ',
  NATIONALITY_MANAGER_CREATE_ERROR = '[Onboarding] call NationalityManagerCreate service error ',
  CLEAN_STATE = '[Onboarding] call NationalityManagerCreate service CLEAN_STATE'
}

export enum currencyTypeTypes {
  CONFIG_REQUEST_MANAGER = '[Onboarding] call currencyType service ',
  CONFIG_REQUEST_MANAGER_SUCCESS = '[Onboarding] call currencyType service success ',
  CONFIG_REQUEST_MANAGER_ERROR = '[Onboarding] call currencyType service error ',
  CLEAN_STATE = '[Onboarding] call currencyType service CLEAN_STATE'
}

export enum FinancialDataManagerCreateTypes {
  FINANCIAL_DATA_MANAGER_CREATE = '[Onboarding] call FinancialDataManagerCreate service ',
  FINANCIAL_DATA_MANAGER_CREATE_SUCCESS = '[Onboarding] call FinancialDataManagerCreate service success ',
  FINANCIAL_DATA_MANAGER_CREATE_ERROR = '[Onboarding] call FinancialDataManagerCreate service error ',
  CLEAN_STATE = '[Onboarding] call FinancialDataManagerCreate service CLEAN_STATE'
}

export enum TermsAndConditionsManagerCreateTypes {
  TERMS_AND_CONDITIONS_MANAGER_CREATE = '[Onboarding] call TermsAndConditionsManagerCreate service ',
  TERMS_AND_CONDITIONS_MANAGER_CREATE_SUCCESS = '[Onboarding] call TermsAndConditionsManagerCreate service success ',
  TERMS_AND_CONDITIONS_MANAGER_CREATE_ERROR = '[Onboarding] call TermsAndConditionsManagerCreate service error ',
  CLEAN_STATE = '[Onboarding] call TermsAndConditionsManagerCreate service CLEAN_STATE'
}

export enum PassiveDocumentCreationTypes {
  PASSIVE_DOCUMENT_CREATION = '[Onboarding] call PassiveDocumentCreation service ',
  PASSIVE_DOCUMENT_CREATION_SUCCESS = '[Onboarding] call PassiveDocumentCreation service success ',
  PASSIVE_DOCUMENT_CREATION_ERROR = '[Onboarding] call PassiveDocumentCreation service error ',
  CLEAN_STATE = '[Onboarding] call PassiveDocumentCreation service CLEAN_STATE'
}

export enum PepTypes {
  PEP_SAVE_DATA = '[Onboarding] pep save data ',
  SEND_PEP_DATA = '[Onboarding] attempt to send pep data ',
  SEND_PEP_DATA_SUCCESS = '[Onboarding] pep data sent successfully',
  SEND_PEP_DATA_ERROR = '[Onboarding] pep data sent error '
}

export enum CustomerChallengeGenerateTypes {
  CUSTOMER_CHALLENGE_GENERATE = '[Onboarding] call CustomerChallengeGenerate service ',
  CUSTOMER_CHALLENGE_GENERATE_SUCCESS = '[Onboarding] call CustomerChallengeGenerate service success ',
  CUSTOMER_CHALLENGE_GENERATE_ERROR = '[Onboarding] call CustomerChallengeGenerate service error ',
  CLEAN_STATE = '[Onboarding] call CustomerChallengeGenerate service CLEAN_STATE'
}

export enum CheckTokenTypes {
  CHECK_TOKEN = '[Onboarding] call checkToken service ',
  CHECK_TOKEN_SUCCESS = '[Onboarding] call checkToken service success ',
  CHECK_TOKEN_ERROR = '[Onboarding] call checkToken service error ',
  CLEAN_STATE = '[Onboarding] call checkToken service CLEAN_STATE'
}

export enum PasswordCreateTypes {
  PASSWORD_CREATE = '[Onboarding] call passwordCreate service ',
  PASSWORD_CREATE_SUCCESS = '[Onboarding] call passwordCreate service success ',
  PASSWORD_CREATE_ERROR = '[Onboarding] call passwordCreate service error ',
  CLEAN_STATE = '[Onboarding] call passwordCreate service CLEAN_STATE'
}

export enum CreateUserAccountType {
  CREATE_USER_ACCOUNT = '[Onboarding] call createUserAccount service ',
  CREATE_USER_ACCOUNT_SUCCESS = '[Onboarding] call createUserAccount service success ',
  CREATE_USER_ACCOUNT_ERROR = '[Onboarding] call createUserAccount service error ',
  CLEAN_STATE = '[Onboarding] call createUserAccount service CLEAN_STATE'
}

export enum CIGOTypes {
  CIGO = '[Onboarding] call CIGO service ',
  CIGO_SUCCESS = '[Onboarding] call CIGO service success ',
  CIGO_ERROR = '[Onboarding] call CIGO service error ',
  CLEAN_STATE = '[Onboarding] call CIGO service CLEAN_STATE'
}

export enum CreateProductTypes {
  CREATEPRODUCT = '[Onboarding] call CREATEPRODUCT service ',
  CREATEPRODUCT_SUCCESS = '[Onboarding] call CREATEPRODUCT service success ',
  CREATEPRODUCT_ERROR = '[Onboarding] call CREATEPRODUCT service error ',
  CLEAN_STATE = '[Onboarding] call CREATEPRODUCT service CLEAN_STATE'
}

export enum ClientExternalChallengeTypes {
  CLIENT_EXTERNAL_CHALLENGE = '[Onboarding] call CLIENT_EXTERNAL_CHALLENGE service ',
  CLIENT_EXTERNAL_CHALLENGE_SUCCESS = '[Onboarding] call CLIENT_EXTERNAL_CHALLENGE service success ',
  CLIENT_EXTERNAL_CHALLENGE_ERROR = '[Onboarding] call CLIENT_EXTERNAL_CHALLENGE service error ',
  CLEAN_STATE = '[Onboarding] call CLIENT_EXTERNAL_CHALLENGE service CLEAN_STATE'
}

export enum ClientExternalIdentityTypes {
  CLIENT_EXTERNAL_IDENTITY = '[Onboarding] call CLIENT_EXTERNAL_IDENTITY service ',
  CLIENT_EXTERNAL_IDENTITY_SUCCESS = '[Onboarding] call CLIENT_EXTERNAL_IDENTITY service success ',
  CLIENT_EXTERNAL_IDENTITY_ERROR = '[Onboarding] call CLIENT_EXTERNAL_IDENTITY service error ',
  CLEAN_STATE = '[Onboarding] call CLIENT_EXTERNAL_IDENTITY service CLEAN_STATE'
}

export enum PioTypes {
  PIO = '[Onboarding] call PIO service ',
  PIO_SUCCESS = '[Onboarding] call PIO service success ',
  PIO_ERROR = '[Onboarding] call PIO service error ',
  CLEAN_STATE = '[Onboarding] call PIO service CLEAN_STATE'
}

export enum ClientStatePasswordGetTypes {
  CLIENT_STATE_PASSWORD_GET = '[Onboarding] call clientStatePasswordGet service ',
  CLIENT_STATE_PASSWORD_GET_SUCCESS = '[Onboarding] call clientStatePasswordGet service success ',
  CLIENT_STATE_PASSWORD_GET_ERROR = '[Onboarding] call PIclientStatePasswordGetO service error ',
  CLEAN_STATE = '[Onboarding] call clientStatePasswordGet service CLEAN_STATE'
}

export enum DocumentSignatureTypes {
  DOCUMENT_SIGNATURE = '[Onboarding] call DOCUMENT_SIGNATURE service ',
  DOCUMENT_SIGNATURE_SUCCESS = '[Onboarding] call DOCUMENT_SIGNATURE service success ',
  DOCUMENT_SIGNATURE_ERROR = '[Onboarding] call DOCUMENT_SIGNATURE service error ',
  CLEAN_STATE = '[Onboarding] call DOCUMENT_SIGNATURE service CLEAN_STATE'
}

export enum TriTypes {
  TRI = '[Onboarding] call TRI service ',
  TRI_SUCCESS = '[Onboarding] call TRI service success ',
  TRI_ERROR = '[Onboarding] call TRI service error ',
  CLEAN_STATE = '[Onboarding] call TRI service CLEAN_STATE'
}

export enum TreTypes {
  TRE = '[Onboarding] call TRE service ',
  TRE_SUCCESS = '[Onboarding] call TRE service success ',
  TRE_ERROR = '[Onboarding] call TRE service error ',
  CLEAN_STATE = '[Onboarding] call TRE service CLEAN_STATE'
}

export enum validateSessionTypes {
  VALIDATE_SESSION = '[Onboarding] call Validate Session service ',
  VALIDATE_SESSION_SUCCESS = '[Onboarding] call Validate Session service success ',
  VALIDATE_SESSION_ERROR = '[Onboarding] call Validate Session service error ',
  CLEAN_STATE = '[Onboarding] call Validate Session service CLEAN_STATE'
}

export enum ApiResponseStatus {
  OK = '00',
  FAIL = '01',
  DISABLE = '02',
  ERROR = 'error'
}

export enum CigoResponseLight {
  GREEN = '00',
  YELLOW = '01',
  RED = '02'
}

export enum OCRResponseStatus {
  ERROR = 'error',
  FAIL = 'fail',
  OK = 'ok'
}

export enum CustomerDocumentType {
  DNI = '1',
  CE = '4'
}

export enum activitiesCodes {
  DESEMPLEADO = '0',
  AMA_DE_CASA = '8',
  ESTUDIANTE = '7',
  INDEPENDIENTE = '3',
  DEPENDIENTE = '1',
  JUBILADO = '11',
  INFORMAL = '9',
  FFAA = '10'
}

export enum ModeTranslate {
  IN = 'fast track',
  WEB = 'public site not client',
  WEB_PF = 'public site executive',
  PF = 'private site executive'
}

export enum AccountNames {
  Ahorro = 'Cuenta de Ahorro Clásica',
  Flex = 'Cuenta de Ahorro Banco Falabella',
  CTS = 'Cuenta CTS',
  AhorroSueldo = ''
}

export enum FooterText {
  Ahorro = '*Tasa rendimiento efectiva anual <br> **Las transferencias interbancarias inmediatas son gratuitas y funcionan de lunes a domingo entre las 00:15 horas y 23:45 horas, incluido feriados.',
  Flex = '(*) Las transferencias interbancarias inmediatas son gratuitas y funcionan de lunes a domingo entre las 00:15 horas y 23:45, incluido feriados.',
  CTS = '',
  AhorroSueldo = '¡Trasládate hoy y accede a un bono de hasta S/ 400!'
}

export enum OfferMainImg {
  Ahorro = 'assets/icons/offer/piggy.png',
  Flex = 'assets/icons/offer/FIFCardThumbnail.svg',
  CTS = 'assets/icons/offer/piggy.png',
  AhorroSueldo = 'assets/icons/offer/employee/money-direct-deposit.png'
}

export enum CurrencyType {
  S = 1,
  D = 2
}

export type Utm = Record<string, string>;

export enum GenericErrorType {
  DEFAULT_ERROR = 'DEFAULT_ERROR',
  SUCURSAL_DERIVATION = 'SUCURSAL_DERIVATION',
  REJECTED_REQUEST = 'REJECTED_REQUEST',
  TIME_OUT = 'TIME_OUT',
  PROCCESS_ERROR = 'PROCCESS_ERROR',
  EXIST_CLIENT = 'EXIST_CLIENT',
  ABR_YELLOW_DERIVATION = 'ABR_YELLOW_DERIVATION',
  RETAKE_ABR_DERIVATION = 'RETAKE_ABR_DERIVATION'
}

export enum AccountIntention {
  AHORRO_SUELDO = 'ahorro-sueldo',
  AHORRRO = 'ahorro-clasica',
  SUELDO = 'ahorro-falabella',
  MANCOMUNADA = 'ahorro-mancomunada',
  CTS = 'cts'
}
